import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import { type SbSharedRefineMenuFilterArtOrientation_itemSearch$key } from './__generated__/SbSharedRefineMenuFilterArtOrientation_itemSearch.graphql.ts';
import { type SbSharedRefineMenuFilters_filters$data } from './__generated__/SbSharedRefineMenuFilters_filters.graphql.ts';
import { type ArrayElement } from 'dibs-ts-utils/exports/ArrayElement.ts';

// components
import { SbSharedRefineMenuMultiSelectList } from '../SbSharedRefineMenuMultiSelect/SbSharedRefineMenuMultiSelectList.jsx';

const itemSearchFragment = graphql`
    fragment SbSharedRefineMenuFilterArtOrientation_itemSearch on ItemSearchQueryConnection {
        ...SbSharedRefineMenuMultiSelectList_itemSearch
    }
`;
type Props = {
    itemSearch: SbSharedRefineMenuFilterArtOrientation_itemSearch$key;
    filterName: string;
    values: ArrayElement<SbSharedRefineMenuFilters_filters$data>['values'];
    trackingOptions?: Record<string, unknown>;
};

export const SbSharedRefineMenuFilterArtOrientation: FC<Props> = ({
    filterName,
    values,
    itemSearch: itemSearchRef,
    trackingOptions,
}) => {
    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);

    return (
        <SbSharedRefineMenuMultiSelectList
            itemSearch={itemSearch}
            filterName={filterName}
            values={values}
            trackingOptions={trackingOptions}
        />
    );
};
